"use client";

import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { reloadOnChunkLoadError } from "@/lib/chunk-recovery";
/**
 * global-error.tsx — fallback TERAKHIR saat root layout itu sendiri error.
 * WAJIB punya <html> dan <body> tags (menggantikan root layout sementara).
 * Ini adalah satu-satunya error boundary yang menangkap error di root layout.
 * Error dilaporkan ke Sentry (pola docs Next.js). Token-based → adapts to
 * dark mode (next-themes class may be absent here, renders light).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Report ke Sentry + ChunkLoadError pasca-deploy → hard reload sekali
  // (lihat error.tsx).
  useEffect(() => {
    Sentry.captureException(error);
    reloadOnChunkLoadError(error);
  }, [error]);
  return (
    <html lang="id" suppressHydrationWarning>
      <body className="bg-background min-h-screen antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
          <div className="bg-destructive/10 flex h-14 w-14 items-center justify-center rounded-2xl">
            <svg
              className="text-destructive h-7 w-7"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-foreground text-lg font-bold">Aplikasi bermasalah</h2>
            <p className="text-muted-foreground mt-1 text-sm">
              Terjadi kesalahan sistem. Silakan coba muat ulang.
            </p>
            {error.digest && (
              <p className="text-muted-foreground/70 mt-2 text-xs">
                Kode: {error.digest}
              </p>
            )}
          </div>
          <Button type="button" onClick={reset} size="xl">
            Muat ulang
          </Button>
        </div>
      </body>
    </html>
  );
}
